import { Button } from '@bambi/component-library/src/components/Button/Button';
import { TrashIcon } from '@heroicons/react/24/outline';

import { FormErrorMessage } from 'src/common/FormErrorMessage';
import { Modal } from 'src/common/primitives/Modal';

export function DeleteModal({
  open,
  setOpen,
  onCancel,
  onConfirm,
  error,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  error: string | null;
}) {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      contentClassnames="max-w-md"
      title="Delete Passenger"
    >
      <div className="flex justify-center" data-testid="delete-passenger-modal">
        <div
          className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-error-100 text-error-700"
          style={{
            border: '8px solid #FEF3F2',
            borderRadius: '28px',
          }}
        >
          <TrashIcon className="w-5" />
        </div>
      </div>
      {error && (
        <div className="mt-4">
          <FormErrorMessage>{error}</FormErrorMessage>
        </div>
      )}
      <h4 className="mt-4 text-center text-lg font-medium text-gray-900">
        Delete this passenger
      </h4>
      <p className="text-sm text-gray-500">
        Are you sure you want to delete this passenger?
      </p>
      <div className="mt-4 grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6">
        <Button className="sm:col-span-3" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className="sm:col-span-3"
          type="submit"
          variant="primary-danger"
          onClick={onConfirm}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
}
